import { base } from '@modules';
import { ArticleLibrarySchema } from './ArticleLibrary.schema';

export const initialState: ArticleLibrarySchema = {
  list: {
    ...base.state,
    data: [],
  },
};
